module.exports = __webpack_public_path__ + "media/images/ic-index-sell-af4de81f9ac52216861de573089360dc.svg";